import classnames from "classnames";
import { ReactNode } from "react";

export type FilterTabProps = {
  children: ReactNode;
  isSelected: boolean;
  onClick: () => void;
  disabled?: boolean;
  classNames?: string;
};

export const FilterTab = ({
  children,
  isSelected,
  onClick,
  disabled,
  classNames,
}: FilterTabProps) => {
  return (
    <button
      onClick={onClick}
      className={classnames(
        "all:unset t-px-6 t-py-4 t-rounded-md t-cursor-pointer t-transition-colors t-ease-in-out t-border t-border-solid",
        {
          "t-border-purple-40 hover:t-border-purple-40 active:t-border-purple-40":
            isSelected,
          "hover:t-bg-surface-lighter-grey hover:t-border-neutral-20 active:t-border-purple-40 t-border-neutral-10":
            !isSelected && !disabled,
          "t-cursor-not-allowed t-opacity-50": disabled,
          [classNames || ""]: Boolean(classNames),
        }
      )}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
